
import { EventFormValues } from '../../schemas/eventFormSchema';
import { EventStatus } from '@/services/eventService';

// Provides default values for the event form
export const getFormDefaults = (): EventFormValues => {
  const now = new Date();
  const startTime = new Date();
  startTime.setHours(now.getHours(), 0, 0, 0); // Set to the current hour with no minutes
  
  const endTime = new Date();
  endTime.setHours(now.getHours() + 1, 0, 0, 0); // One hour later with no minutes
  
  return {
    eventName: "",
    description: "",
    startDate: new Date(),
    endDate: new Date(),
    startTime,
    endTime,
    city: "",
    venueName: "",
    address: "",
    region: "",
    isOnline: false,
    eventUrl: "https://",
    eventType: "conference",
    creditPoints: "",
    postAccredited: false,
    maxAttendees: "",
    imageUrl: "",
    professions: [], // Initialize with empty array
    timeNotSpecified: true, // Default to no specific time
    registrationUrl: "",
    status: EventStatus.DRAFT, // Default status
  };
};
